import React, { useState } from 'react';
import { useHistory } from "react-router-dom";

import bent from 'bent';

const CreateRoom = ({user}) => {
    const roomCall = bent(`https://${process.env.REACT_APP_API_DOMAIN}/`, 'POST', 'json', 200);
    const history = useHistory();
    const [title, setTitle] = useState('')
    return (
        <>
        <div className="content">
            <h2>LIVE INTV</h2>
            <form onSubmit={async e => {
                e.preventDefault();
                const room = await roomCall('room/new', {user, title, record:false});
                
                history.push(`/rooms/${room.room_id}`);
            }}>
                <label>Room Title</label>
                <input type="text" onChange={e => setTitle(e.target.value)} />
                <input type="submit" value="Create Room &gt;" />
            </form>
        </div>
        </>
    )
}

export default CreateRoom;